
<template>
<div>
  <div class="wrapper" @click="handleClick">
    <div class="image">
      <slot></slot>
    </div>
    <div class="title">{{title}}</div>
     <div>
    <div class="rightText">{{rightText}}</div>
    </div>
    <div class="right-arr" >
      <i class="icon" v-if="showClickIcon" >&#xe601;</i>
    </div>
  </div>
  <div class="bottom-divide"></div>
 </div> 
</template>

<script>
export default {
  props: {
    title: String,
    rightText: String,
    showClickIcon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    handleClick (i) {
      this.$emit('click', i)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var'
$bottom-line-color = #CCD5D8
  .bottom-divide
    height  1px
    background $bottom-line-color
    margin-left pt(20)
    margin-right pt(20)
  .wrapper
    display flex
    background-color white
    height pt(100)
    border-radius pt(20)
    align-items center
    .image
      margin-left pt(30)
      width  pt(60)
      margin-right pt(15)
    .title
      flex-grow 1
    .rightText
      flex-grow 1
      color #525252
    .right-arr
      height pt(35)
      width pt(35)
      color #9C9D9E
      margin-right pt(20)
</style>



// WEBPACK FOOTER //
// info-item.vue?9172f858